import React, { useEffect } from "react";
import { useDraw } from "./MapDrawController";
import { FaDrawPolygon, FaTrashAlt } from "react-icons/fa";

const CustomDrawButtons = () => {
  const { enterDrawingMode, deletePolygon, isDrawingMode, polygonArea } = useDraw();

  // Function to start drawing mode with enhanced debugging
  const startDrawing = () => {
    console.log("Draw button clicked - starting drawing mode");

    // Force the labels map to be interactive before calling enterDrawingMode
    const labelsMapContainer = document.getElementById('labelsMap');
    if (labelsMapContainer) {
      console.log("Setting pointer events to auto on labelsMap");
      labelsMapContainer.style.pointerEvents = 'auto';
      labelsMapContainer.style.zIndex = '100';
      document.body.classList.add('drawing-active');
    } else {
      console.warn("labelsMap element not found!");
    }

    // Try to access draw control directly for debugging
    const directDrawControl =
      window.mapboxDrawInstance ||
      window.labelsMapInstance?.__draw;

    if (directDrawControl) {
      console.log("Found direct draw control, attempting to activate draw mode");
      try {
        // Directly change to drawing mode
        directDrawControl.changeMode('draw_polygon');
      } catch (err) {
        console.error("Error directly changing drawing mode:", err);
      }
    } else {
      console.warn("No direct draw control found");
    }

    // Finally call the context function
    enterDrawingMode();
  };

  // Function to delete the current polygon
  const handleDeletePolygon = () => {
    console.log("Delete button clicked");
    deletePolygon();
  };

  // Hide Mapbox's default controls and ensure labels map is interactive when drawing
  useEffect(() => {
    const hideMapboxControls = () => {
      // Hide all Mapbox draw controls
      const mapboxControls = document.querySelectorAll(".mapbox-gl-draw_ctrl, .mapboxgl-ctrl-group");
      mapboxControls.forEach(control => {
        if (control) {
          control.style.display = "none";
          control.style.visibility = "hidden";
          control.style.opacity = "0";
        }
      });
    };

    const forceLabelsMapInteractive = () => {
      if (isDrawingMode) {
        const labelsMapContainer = document.getElementById('labelsMap');
        if (labelsMapContainer) {
          labelsMapContainer.style.pointerEvents = 'auto';
          labelsMapContainer.style.zIndex = '100';
        }
      }
    };

    // Run this on initial render and periodically
    hideMapboxControls();
    forceLabelsMapInteractive();

    const interval = setInterval(() => {
      hideMapboxControls();
      forceLabelsMapInteractive();
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [isDrawingMode]);

  // Button styles with enhanced visual feedback
  const buttonStyle = (active) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "44px",
    height: "44px",
    backgroundColor: active ? "#2e3a59" : "#fff",
    color: active ? "#fff" : "#2e3a59",
    border: `2px solid ${active ? "#1a2233" : "#e1e5eb"}`,
    borderRadius: "8px",
    cursor: "pointer",
    boxShadow: active ? "0 2px 8px rgba(0,0,0,0.2)" : "0 2px 4px rgba(0,0,0,0.1)",
    transition: "all 0.2s ease",
    margin: "0 5px",
    position: "relative",
    outline: "none"
  });

  return (
    <div
      id="custom-draw-buttons"
      style={{
        position: "fixed",
        bottom: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        padding: "12px 16px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        zIndex: 10000, // Extremely high z-index to ensure it's above everything
        fontFamily: "'Figtree', sans-serif",
      }}
    >
      <button
        onClick={startDrawing}
        style={buttonStyle(isDrawingMode)}
        title="Draw Polygon"
      >
        <FaDrawPolygon size={20} />
        {isDrawingMode && (
          <span
            style={{
              position: "absolute",
              top: "-8px",
              right: "-8px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              backgroundColor: "#4caf50",
              border: "2px solid white"
            }}
          />
        )}
      </button>

      <button
        onClick={handleDeletePolygon}
        style={buttonStyle(false)}
        title="Delete Polygon"
        disabled={polygonArea <= 0}
      >
        <FaTrashAlt size={18} />
      </button>

      {/* Display area if polygon exists */}
      {polygonArea > 0 && (
        <div style={{
          marginLeft: "10px",
          display: "flex",
          alignItems: "center",
          fontSize: "15px",
          fontWeight: "600",
          color: "#2e3a59",
          background: "#f0f4f8",
          padding: "8px 12px",
          borderRadius: "8px"
        }}>
          Area: {polygonArea.toFixed(2)} ha
        </div>
      )}
    </div>
  );
};

export default CustomDrawButtons;
